import {unsafe_bindActions} from '../redux/utils'
import {bindActionCreators} from 'redux'
import {updateFeatures} from '../features/actions'

function FeaturesPage() {};

FeaturesPage.features = {};
FeaturesPage.handlers = {};

FeaturesPage.sentAjaxRequests = {};

FeaturesPage.featureMenuItemIds = {};


FeaturesPage.FeatureBlock = function ( featureCode, enabled, switchCallback )
{
    if( !featureCode )
        return;

    var me = this;

    this.featureCode = featureCode;
    this.switcher = enabled != null ? new TumblerSwitch(enabled, function() { me.callback(); } ) : null;
    this.mainDiv = null;
    this.switchCallback = switchCallback;
    this.subFeatureCodes = [];
};

FeaturesPage.FeatureBlock.prototype.getFeatureCode = function()
{
    return this.featureCode;
};

FeaturesPage.FeatureBlock.prototype.render = function( featureElId )
{
    this.mainDiv = document.getElementById( featureElId );
    this.updateMainDivClass();

    var nameDiv = document.createElement("DIV");
    nameDiv.className = "name";

    this.nameContainer = document.createElement("span");
    this.nameContainer.className = "nameContainer";

    var nameSpan = document.createElement("span");
    nameSpan.innerHTML = escapeHtmlSymbols( messageResource.getMessage( "features." + this.featureCode + ".title" ) );
    nameSpan.className = "nameSpan";

    this.mainDiv.appendChild( nameDiv );
    nameDiv.appendChild( this.nameContainer );
    this.nameContainer.appendChild( nameSpan );
    if( this.switcher )
        this.switcher.appendAsChildTo( this.mainDiv );
    else
    {
        var availableInProSpan = document.createElement( "span" );
        if (isOlVersion) {
            availableInProSpan.innerHTML = messageResource.getMessage("features.available_in_paid")
        } else {
            availableInProSpan.innerHTML = messageResource.getMessage("features.available_in_pro")
        }
        availableInProSpan.className = "availableInPro";
        this.mainDiv.appendChild( availableInProSpan );
    }

    this.addNameClickHandler();
};

FeaturesPage.FeatureBlock.prototype.getBaseCssClassName = function()
{
    return "feature";
};

FeaturesPage.FeatureBlock.prototype.updateMainDivClass = function()
{
    this.mainDiv.className = this.getBaseCssClassName() + " " + ( this.switcher ? this.switcher.isEnabled() ? "on" : "off" : "off notAvailable" );
};

FeaturesPage.FeatureBlock.prototype.addNameClickHandler = function()
{
    var featureBlock = this;
    $(this.nameContainer ).on("mouseover", function(){
        $(featureBlock.nameContainer).addClass('hovered');
    });
    $(this.nameContainer ).on("mouseout", function(){
        $(featureBlock.nameContainer).removeClass('hovered');
    });
    $(this.nameContainer ).click(function(){
        $(featureBlock.nameContainer).addClass('selected');
    });
    var onCloseCallback = function() {
        $(featureBlock.nameContainer).removeClass('selected');
    };
    $(this.nameContainer ).click(function(){
        featureBlock.showDescriptionPopup(onCloseCallback);
    });
};

FeaturesPage.FeatureBlock.prototype.updateSettingsMenu = function() {
    var menuItemId = FeaturesPage.featureMenuItemIds[this.getFeatureCode()];
    if (menuItemId) {
        var menuItem = document.getElementById(menuItemId);
        if (this.isEnabled()) {
            showElement(menuItem);
        } else {
            hideElement(menuItem);
        }
    }
}

FeaturesPage.FeatureBlock.prototype.isEnabled = function()
{
    return this.switcher == null ? null : this.switcher.isEnabled();
};

FeaturesPage.FeatureBlock.prototype.setEnabled = function()
{
    this.switcher.setEnabled();
    this.updateMainDivClass();
    this.updateSettingsMenu();
};

FeaturesPage.FeatureBlock.prototype.setDisabled = function()
{
    this.switcher.setDisabled();
    this.updateMainDivClass();
    this.updateSettingsMenu();
};

FeaturesPage.FeatureBlock.prototype.callback = function()
{
    this.updateMainDivClass();
    this.updateSettingsMenu();
    this.switchCallback( this );
    FeaturesPage.actions.updateFeatures({[this.getFeatureCode()]: this.isEnabled()})
};

FeaturesPage.FeatureBlock.prototype.getParentFeatureCode = function()
{
    return null;
};

FeaturesPage.FeatureBlock.prototype.getSubFeatureCodes = function()
{
    return this.subFeatureCodes;
};

FeaturesPage.FeatureBlock.prototype.addSubFeatureCode = function( subFeatureCode )
{
    this.subFeatureCodes.push( subFeatureCode );
};

FeaturesPage.FeatureBlock.prototype.showDescriptionPopup = function(onCloseCallback)
{
    FeaturesPage.descriptionPopup.setTitle(escapeHtmlSymbols( messageResource.getMessage( "features." + this.featureCode + ".title" ) ));
    FeaturesPage.descriptionPopup.setContent("FEATURE_"+this.featureCode+"_description");
    FeaturesPage.descriptionPopup.setOnCloseCallback(onCloseCallback);
    FeaturesPage.descriptionPopup.showAt(this.nameContainer);
};

FeaturesPage.SubFeatureBlock = function( featureCode, enabled, switchCallback, subfeatureInfo )
{
    FeaturesPage.FeatureBlock.call( this, featureCode, enabled, switchCallback );
    this.parentFeatureCode = subfeatureInfo.parentFeatureCode;
    this.isLastInList = subfeatureInfo.isLast;
};

FeaturesPage.SubFeatureBlock.prototype = new FeaturesPage.FeatureBlock();

FeaturesPage.SubFeatureBlock.prototype.getBaseCssClassName = function()
{
    return "feature subfeature" + ( this.isLastInList ? "" : " notLast" );
};

FeaturesPage.SubFeatureBlock.prototype.getParentFeatureCode = function()
{
    return this.parentFeatureCode;
};



FeaturesPage.featureSwitchCallback = function( featureBlock )
{
    var handler = FeaturesPage.handlers[ featureBlock.getFeatureCode() ];

    if( featureBlock.isEnabled() )
    {
        if( handler && !handler.featureTurnedOn(featureBlock)  )
        {
            return;
        }

        var parentFeatureCode = featureBlock.getParentFeatureCode();
        if( parentFeatureCode )
        {
            var parentFeature = FeaturesPage.features[ parentFeatureCode ];
            if( !parentFeature.isEnabled() )
                parentFeature.setEnabled();
        }
    }
    else
    {
        if( handler && !handler.featureTurnedOff(featureBlock)  )
        {
            return;
        }

        var subFeatureCodes = featureBlock.getSubFeatureCodes();
        for( var f = 0; f < subFeatureCodes.length; f++ )
        {
            var subFeature = FeaturesPage.features[ subFeatureCodes[f] ];
            if( subFeature.isEnabled() )
                subFeature.setDisabled();
        }
    }

    FeaturesPage.sendFeatureAjaxRequest(featureBlock);
};


FeaturesPage.sendFeatureAjaxRequest = function( featureBlock, serviceMethodConfig, timeout )
{
    var featureCode = featureBlock.getFeatureCode();
    var featureState = featureBlock.isEnabled();
    if (FeaturesPage.sentAjaxRequests[featureCode])
    {
        FeaturesPage.sentAjaxRequests[featureCode].request.abort();
        featureState = FeaturesPage.sentAjaxRequests[featureCode].state;
    }

    var featureName = messageResource.getMessage( "features." + featureCode + ".title" );
    var alertMessagePrefix;
    if (featureState)
        alertMessagePrefix = messageResource.getMessage( "features.subtasks_turn_off_warning.error_enabling", [featureName] );
    else
        alertMessagePrefix = messageResource.getMessage( "features.subtasks_turn_off_warning.error_disabling", [featureName] );
    
    var methodName = !serviceMethodConfig ? "FeaturesService.setEnabled" : serviceMethodConfig.methodName;
    var methodParams = !serviceMethodConfig ? [featureCode, featureBlock.isEnabled()] : serviceMethodConfig.methodParams;
    
    var ajaxRequest = makeRpcCall(methodName, methodParams,
        function() {
            FeaturesPage.sentAjaxRequests[featureCode] = undefined;
            if ( serviceMethodConfig && serviceMethodConfig.callback )
                serviceMethodConfig.callback();
        },
        function(jqXHR, textStatus, errorThrown) {
            if ( serviceMethodConfig && serviceMethodConfig.callback )
                serviceMethodConfig.callback();
            
            if (textStatus != 'abort' ) {
                FeaturesPage.sentAjaxRequests[featureCode] = undefined;
                if (featureState)
                {
                    featureBlock.setDisabled();
                    var parentFeatureCode = featureBlock.getParentFeatureCode();
                    if( parentFeatureCode )
                    {
                        var parentFeature = FeaturesPage.features[ parentFeatureCode ];
                        if(parentFeature.isEnabled() )
                            parentFeature.setDisabled();
                    }
                }
                else
                {
                    featureBlock.setEnabled();
                    var subFeatureCodes = featureBlock.getSubFeatureCodes();
                    for( var f = 0; f < subFeatureCodes.length; f++ )
                    {
                        var subFeature = FeaturesPage.features[ subFeatureCodes[f] ];
                        if( !subFeature.isEnabled() )
                            subFeature.setEnabled();
                    }
                }
                return false;
            }
        },
        alertMessagePrefix,
        timeout
    );

    FeaturesPage.sentAjaxRequests[featureBlock.getFeatureCode()] = {"state": featureState, "request": ajaxRequest};
};



FeaturesPage.FeatureStateChangeHandler = function()
{
};

FeaturesPage.FeatureStateChangeHandler.prototype.featureTurnedOn = function()
{
    return true;
};

FeaturesPage.FeatureStateChangeHandler.prototype.featureTurnedOff = function()
{
    return true;
};


FeaturesPage.TTApprovalHandler = function( showDialogOnTTAEnabling, ttApprovalLastDisablingTimestamp )
{
    FeaturesPage.FeatureStateChangeHandler.call( this );
    this.showDialog = showDialogOnTTAEnabling;
    this.ttApprovalLastDisablingTimestamp = ttApprovalLastDisablingTimestamp;
};

FeaturesPage.TTApprovalHandler.prototype = new FeaturesPage.FeatureStateChangeHandler();

FeaturesPage.TTApprovalHandler.prototype.onConfirmFunction = function ( featureBlock, approveAllWeeks, weekDate, callback ) {
    featureBlock.setEnabled();
    FeaturesPage.sendFeatureAjaxRequest(featureBlock, { 
        methodName: "FeaturesService.setEnabledTTA", 
        methodParams: [true, approveAllWeeks, weekDate],
        callback: callback
    }, LONG_RPC_TIMEOUT);
};

FeaturesPage.TTApprovalHandler.prototype.disableFeature = function ( featureBlock ) {
    //featureBlock.setDisabled();
    FeaturesPage.sendFeatureAjaxRequest(featureBlock, { 
        methodName: "FeaturesService.setEnabledTTA", 
        methodParams: [false, false, null]
    });
};

FeaturesPage.TTApprovalHandler.prototype.featureTurnedOn = function( featureBlock )
{
    if ( !this.showDialog )
        return true;
    
    var self = this;
    featureBlock.setDisabled();
    
    if ( !this.ttaConfirmDialog )
        this.ttaConfirmDialog = new TTAConfirmDialog().init( {
            popupId: "ttaConfirmDialog",
            lastDisablingTimestamp: self.ttApprovalLastDisablingTimestamp,
            submitFunction: function( approveTT, weekDate, callback ) { self.onConfirmFunction(featureBlock, approveTT, weekDate, callback); },
            cancelFunction: function() { /*do nothing*/ }
        });
    
    this.ttaConfirmDialog.show();
    
    return false;
};

FeaturesPage.TTApprovalHandler.prototype.featureTurnedOff = function( featureBlock )
{
    this.disableFeature(featureBlock);
    return false;
};


FeaturesPage.init = function( features, featureDependencies, handlers )
{
    var featureBlock, parentFeatureCode;

    for( var featureCode in features )
    {
        parentFeatureCode = featureDependencies[featureCode];
        if( parentFeatureCode )
            featureBlock = new FeaturesPage.SubFeatureBlock( featureCode, features[ featureCode ], FeaturesPage.featureSwitchCallback, parentFeatureCode );
        else
            featureBlock = new FeaturesPage.FeatureBlock( featureCode, features[ featureCode ], FeaturesPage.featureSwitchCallback );

        FeaturesPage.features[featureCode] = featureBlock;
    }

    for( var subFeatureCode in featureDependencies )
    {
        parentFeatureCode = featureDependencies[ subFeatureCode].parentFeatureCode;
        var parentFeatureBlock = FeaturesPage.features[ parentFeatureCode ];
        if( parentFeatureBlock )
            parentFeatureBlock.addSubFeatureCode( subFeatureCode );
    }

    for( featureCode in FeaturesPage.features )
        FeaturesPage.features[ featureCode ].render( "FEATURE_" + featureCode );

    FeaturesPage.handlers = handlers;

    FeaturesPage.descriptionPopup = new FeaturesPage.DescriptionPopup();
    FeaturesPage.descriptionPopup.init();

    FeaturesPage.actions = unsafe_bindActions((dispatch) => ({
        updateFeatures: bindActionCreators(updateFeatures, dispatch)
    }))
};




FeaturesPage.DescriptionPopup = function()
{

};

FeaturesPage.DescriptionPopup.prototype = {};

FeaturesPage.DescriptionPopup.prototype.init = function()
{
    var self = this;
    this.descriptionPopupClass = "featureDescriptionPopup";
    this.descriptionPopup = new DropdownDialog({
                                                   dialogDiv: "#featureDescriptionPopupContent",
                                                   wrapperClass: this.descriptionPopupClass+" customPopup",
                                                   hideButtons: true,
                                                   hideOnResize: true,
                                                   isWithBeak: true,
                                                   notModal: true,
                                                   onClose: function() { if (self.onCloseCallback) self.onCloseCallback(); }
                                               });
    this.featureDescriptionTitle = $("#featureDescriptionTitle" );
    this.featureDescriptionContent = $("#featureDescriptionContent" );

    this.featureDescriptionTemplates = $("#featureDescriptionTemplates" );

    $("#closeFeatureDescription" ).click(function(){
         self.descriptionPopup.hide();
    });
};

FeaturesPage.DescriptionPopup.prototype.setOnCloseCallback = function(callback)
{
    var self = this;
    this.onCloseCallback = callback;

    var element = $("."+this.descriptionPopupClass)[0];
    // set mouse down outside handler, so that clicks on scroll bar are not handled
    $(document.body).mousedown( function(event)
                               {
                                   if( $(event.target).parents().index(element) == -1 )
                                   {
                                       callback();
                                       self.descriptionPopup.hide();
                                   }
                               });
};

FeaturesPage.DescriptionPopup.prototype.showAt = function(element)
{
    var popupOffsetX = 12;
    var minOffsetX = 95;
    var dx = ($(window).width() + getBodyScrollLeft() - $(element ).offset().left - $(element ).outerWidth() - popupOffsetX) - $("."+this.descriptionPopupClass ).width();
    if (dx < 0)
        popupOffsetX = dx;
    var offsetX = popupOffsetX + $(element ).outerWidth();
    if (offsetX < minOffsetX)
        offsetX = minOffsetX;

    this.descriptionPopup.showAt(element, {my: "left center", at: "left center", collision: "none", offset: offsetX + "px 0"});
    this.scrollToTop();
};

FeaturesPage.DescriptionPopup.prototype.setTitle = function(title)
{
    this.featureDescriptionTitle.html(title);
};

FeaturesPage.DescriptionPopup.prototype.setContent = function(contentDivId)
{
    this.featureDescriptionContent.find("div" ).remove();
    this.featureDescriptionTemplates.find("#"+contentDivId ).clone().appendTo(this.featureDescriptionContent);
};

FeaturesPage.DescriptionPopup.prototype.scrollToTop = function()
{
    this.featureDescriptionContent.scrollTop(0);
};

export default FeaturesPage



// WEBPACK FOOTER //
// ./web/js/administration/features.js